import React from "react";
import "./Footer.css";

const Footer = () => {
   return (
      <div className="footer">Made with 🔥 by Drishya Poudel</div>
   );
};

export default Footer;
